// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3gwCv","addWidgetButton":"Header_addWidgetButton__2saRw","dashboardTabs":"Header_dashboardTabs__81xEk","active":"Header_active__8Oqfr"};